<template>
  <custom-dialog width="500px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <!-- 用户信息 -->
      <el-form :model="form" :rules="rules" ref="form">
        <el-row>
          <el-col :span="24" v-if="model.type === 'edit' && isAdmin && !model.orgId">
            <el-form-item :label="$t('base_roleDialog.gang_wei_bian_hao')">
              <el-input v-model="roleCode" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_roleDialog.gang_wei_ming_cheng')" prop="roleName">
              <el-input v-model="form.roleName" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_roleDialog.gang_wei_fen_zu')" prop="roleGroupCode" v-if="isHqAdmin">
              <custom-select v-model="form.roleGroupCode" code="role_group_code" placeholder=""></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="isAdmin && !model.orgId">
            <el-form-item :label="$t('base_roleDialog.gang_wei_lei_xing')" prop="roleType">
              <custom-select :disabled="model.type === 'edit'" v-model="form.roleType" code="bas_role_type" :placeholder="$t('Common.com_please_select')"></custom-select>
            </el-form-item>
          </el-col>
          <el-col v-if="platformRoleCodesVisible" :span="24">
            <el-form-item :label="$t('base_roleDialog.zu_zhi_lei_xing')" prop="platformRoleCodes">
              <custom-select v-model="form.platformRoleCodes" code="bas_org_type" :multiple="true"></custom-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveRole">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      isAdmin: false,
      userInfo: {},
      roleId: '',
      roleCode: '',
      form: {
        roleId: '',
        roleDesc: '',
        roleName: '',
        roleType: '',
        roleGroupCode: '',
        state: 1,
        // 岗位组织
        platformRoleCodes: '',
      },
      transfereDicMap: {},
    };
  },
  computed: {
    rules() {
      return {
        roleName: [
          {
            required: true,
            message: this.$t('base_roleDialog.gwmbt'),
          },
          {
            max: 20,
            message: this.$t('Common.com_rules_length_max', [20]),
          },
        ],
        roleType: {
          required: true,
          message: this.$t('base_roleDialog.jslxbt'),
        },
        platformRoleCodes: {
          required: true,
          validator: this.platformRoleCodesValidator,
        },
      };
    },
    // 是否展示platformRoleCodes；  服务角色 或通知角色 时显示且必填
    platformRoleCodesVisible() {
      const roleTypeMap = this.transfereDicMap['bas_role_type'];
      return this.isAdmin && [roleTypeMap.service_role, roleTypeMap.notice_role].includes(this.form.roleType);
    },
    // 是否总部管理员
    isHqAdmin() {
      const userInfo = this.$store.state.userInfo || {};
      return userInfo.bizType === 'HQ' && userInfo.isAdmin === 1;
    },
  },
  mounted() {
    this.getDictionary('bas_role_type,bas_org_type', () => {
      this.userInfo = this.$store.state.userInfo;
      this.transfereDicMap['bas_role_type'] = this.dicListToMap(this.propertyMap.bas_role_type);
      this.transfereDicMap['bas_org_type'] = this.dicListToMap(this.propertyMap.bas_org_type);
      this.isAdmin = this.userInfo.isAdmin && this.userInfo.bizType === this.transfereDicMap['bas_org_type'].platform;
      if (!this.isAdmin || !!this.model.orgId) {
        // 默认自定义角色
        this.form.roleType = this.transfereDicMap['bas_role_type'].org_role;
      }
      this.initDialog();
    });
  },
  methods: {
    platformRoleCodesValidator(rule, value, cb) {
      if (!value || !value.length) {
        cb(new Error(this.$t('Common.com_required')));
      } else {
        cb();
      }
    },
    // 字典列表转为map{code, value}
    dicListToMap(list) {
      const map = {};
      list.forEach((item) => {
        map[item.code] = item.value;
      });
      return map;
    },
    // 初始化
    initDialog: function () {
      if (this.model.type === 'edit') {
        this.roleId = this.model.roleId;
        this.roleCode = this.model.roleCode;
        this.form.roleDesc = this.model.roleDesc;
        this.form.roleGroupCode = this.model.roleGroupCode;
        this.form.roleName = this.model.roleName;
        this.form.roleType = this.model.roleType;
        if (this.model.platformRoleCodes) {
          const platformRoleCodes = Array.isArray(this.model.platformRoleCodes) ? this.model.platformRoleCodes : this.model.platformRoleCodes.split(',');
          this.form.platformRoleCodes = platformRoleCodes;
        }
      }
    },
    // 确认保存岗位
    saveRole: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveAddRole();
        }
        if (this.model.type === 'edit') {
          this.saveEditRole();
        }
      });
    },
    getReqData() {
      const ret = {
        ...this.form,
        orgId: this.model.orgId,
      };
      if (Array.isArray(ret.platformRoleCodes)) {
        ret.platformRoleCodes = ret.platformRoleCodes.join(',');
      }
      return ret;
    },
    // 保存新增岗位
    saveAddRole: function () {
      this.$postJSON(apis.RoleAdd, this.getReqData(), true).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 保存编辑岗位
    saveEditRole: function () {
      this.form.roleId = this.roleId;
      this.$postJSON(apis.RoleUpdate, this.getReqData(), true).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss"></style>
